"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _grid = require("@rebass/grid");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    text-shadow: 2px 2px 0 rgba(0,0,0,0.4);\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    text-transform: uppercase;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 700;\n  \n  &:after {\n    content: '';\n    display: block;\n    opacity: 0.35;\n    ", ";\n  }\n\n  ", ";\n\n  ", "\n\nHeading.defaultProps = {\n  mb: '1.5rem'\n}\n\n  // emphasis prop turns on text shadow\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      border-bottom-style: solid;\n      border-bottom-width: 2px;\n      border-bottom-color: ", ";"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["color: rgb(26, 82, 118);"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["color: ", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["color: white;"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function printHeadingColor(color) {
  if (color) {
    if (color === 'light') {
      return (0, _styledComponents.css)(_templateObject());
    }

    return (0, _styledComponents.css)(_templateObject2(), color);
  }

  return (0, _styledComponents.css)(_templateObject3());
}

function printUnderline(color, underline) {
  if (underline) {
    return (0, _styledComponents.css)(_templateObject4(), color || 'rgb(26, 82, 118)');
  }

  return null;
} // underline => boolean
// emphasis => boolean
// caps => boolean


var Heading = (0, _styledComponents.default)(_grid.Box)(_templateObject5(), function (props) {
  return printUnderline(props.color, props.underline);
}, function (props) {
  return printHeadingColor(props.color);
}, function (props) {
  return props.caps && (0, _styledComponents.css)(_templateObject6());
}, function (props) {
  return props.emphasis && (0, _styledComponents.css)(_templateObject7());
});
var _default = Heading;
exports.default = _default;